<template>
  <div id="recharge">
    <!-- <el-tabs v-model="activeName" @tab-click="handleClick" id="tab-top">
      <el-tab-pane label="精品方案" name="recharge"> -->
    <div class="rechargeItem-box">
      <div class="rechargeItem" v-for="i in 4">
        <div class="mokiusar">
          <i class="el-icon-picture-outline-round"></i>
        </div>
        <div class="rechargeItemTop">
          <!-- <img src="../../../assets/images/indexLogo.png" alt=""> -->
          <span class="rechargSpan"><i></i>LPG-液化石油气</span>
          <div class="moksa">
            <span class="res_chongzhi">总量 80000吨 </span>
            <span class="res_chongzhi">最低购买量 25 吨</span>
          </div>
          <span class="res_chongzhi"><i></i>鄂尔多斯西北能源化工</span>
          <!-- <div class="rechargeType">竞拍</div> -->
        </div>
        <!-- <div class="rechargeItemBot" @click="">
          <span class="rechargSpan"><i></i>总量<span class="en-block"> {{8000}} </span>吨</span>
          <div class="rechargbors">底价 <span class="rends">￥2580 / 吨</span></div>
        </div> -->
      </div>
    </div>
    <!-- </el-tab-pane>
    </el-tabs> -->
  </div>
</template>

<script>
  export default {
    name: "recharge",
    data () {
      return {
        activeName: 'recharge'
      };
    },
    methods: {
      handleClick (tab, event) {
        console.log(tab, event);
      }
    }
  }
</script>

<style lang="less" scoped>
  #recharge {
    /deep/ .el-tabs__nav-scroll {
      border: 1px solid #E5E5E5;
    }

    /deep/ .el-tabs__nav {
      margin-top: 6px;
      margin-left: 20px;
      height: 48px;

      .el-tabs__active-bar {
        background-color: #FF7800;
      }

      .is-active {
        color: #FF7800;
      }

      .el-tabs__item:hover {
        color: #FF7800;
      }

    }
  }

  .mokisa {

    position: absolute;

    top: 0;
  }

  .moksa {

    display: flex;

    justify-content: space-between;
    width: 100%;

  }

  .mokiusar {


    position: absolute;

    right: 20px;
    top: 25px;
    z-index: 222;



  }

  .rechargeItem {
    width: 290px;
    overflow: hidden;
    border-radius: 20px;
    margin-bottom: 20px;
    border: 1px solid #CCDDFF;

    position: relative;
  }

  .rechargeItemTop {
    background: #ffffff;
    /* border: 1px solid #CCDDFF; */
    /* opacity: 0.77; */
    /* border-radius: 10px; */
    color: #ffffff;
    position: relative;
    padding: 20px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    /* border: 1px solid #CCDDFF; */


    img {
      position: absolute;
      top: 40%;
      opacity: 0.2;
    }

    .rechargSpan {
      font-size: 20px;
      font-family: Source Han Sans CN;
      font-weight: 500;
      color: #0D1142;
    }

    .res_chongzhi {
      font-size: 14px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #666666;
    }

    span {

      font-size: 14px;
      display: block;
      margin-bottom: 25px;
      cursor: pointer;
    }

    &>span:nth-of-type(1) {
      /* font-size: 28px; */

      i {
        font-size: 14px;
        margin-right: 10px;
      }
    }

    /* .rechargeType {
      position: absolute;
      background: #fd5b5b;
      color: #FFFFFF;
      width: 100px;
      height: 40px;
      top: 1px;
      right: -30px;
      line-height: 40px;
      transform: rotate(45deg);
    } */
  }

  .rechargeItemBot {
    background: #F2F6FF;
    /* opacity: 0.77; */
    /* background: #f3f3f3;
    color: #333333;
    height: 40px;
    line-height: 40px; */
    cursor: pointer;
    padding: 20px;
    text-align: left;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
  }

  .rends {
    font-size: 22px;
    font-family: Source Han Sans CN;
    font-weight: bold;
    color: #F53041;
  }

  .en-block {
    color: #3A78FA;
  }

  .rechargeItem-box {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    /* padding: 0 30px; */

    margin-top: 20px;
    position: relative;
  }

  .rechargbors {


    margin-top: 15px;
  }

  #tab-top {
    border: 1px solid #E5E5E5;
  }

</style>



// WEBPACK FOOTER //
// src/view/commodity.vue